import apiFetch from '@wordpress/api-fetch';

const registerCustomer = async (data) => {
    return await apiFetch({
        path: 'rc-wco/v1/add-customer',
        method: 'POST',
        data: {
            'location_id' : data.location,
            'customer_phone': data.phone
        }
    }).then((registrationResult) => {
        return registrationResult;
    })
}

export { registerCustomer };